import { LngLatLike } from "react-map-gl/maplibre";

/**
 * Normalize LngLatLike to a consistent format with lng/lat properties.
 *
 * Accepts any LngLatLike format:
 * - Array: [lng, lat]
 * - Object with lng: { lng, lat }
 * - Object with lon: { lon, lat }
 * - LngLat instance from maplibre-gl
 *
 * @param point - The point in any LngLatLike format
 * @returns Normalized object with lng and lat properties
 */
export function normalizeLngLat(point: LngLatLike): { lng: number; lat: number } {
  if (Array.isArray(point)) {
    return { lng: point[0], lat: point[1] };
  }
  if ("lon" in point && "lat" in point) {
    return { lng: point.lon, lat: point.lat };
  }
  // For objects with lng property (including LngLat instances)
  return { lng: point.lng, lat: point.lat };
}
